module.exports = __webpack_public_path__ + "media/images/lb/582-9ff735f40f4b45ef3b4a0c5d2b290f9a.svg";